import { Box, styled, Typography } from "@mui/material";
import { formatMoney } from "../../../utils/StringUtils";
import { MOBILE_SCREEN_SIZE, TABLET_SCREEN_SIZE } from "@brandclub/common-ui";

const TotalLineItemContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  fontSize: 16,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    fontSize: 14,
  },
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    fontSize: 14,
  },
  "&.bold": {
    fontSize: 20,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 16,
    },
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 16,
    },
  },
});

export const TotalLineItem = ({
  label,
  value,
  zeroString = "",
  bold,
}: {
  label: string;
  value: number;
  zeroString?: string; // String to render if 0
  bold?: boolean;
}) => {
  return (
    <TotalLineItemContainer className={bold ? "bold" : ""}>
      <Typography fontSize={"inherit"} fontWeight={bold ? 600 : 500}>
        {label}
      </Typography>
      <Typography fontSize={"inherit"} fontWeight={bold ? 600 : 500}>
        {value ? formatMoney(value) : zeroString || formatMoney(0)}
      </Typography>
    </TotalLineItemContainer>
  );
};
